$(function() {
    // #122598 - Change the font of titles to Noto Sans Bold on the Vietnamese and Armenian website.
    // Wasn't able to make it work with SCSS alone because we can't tell the language of the website before compiling.
    if ($('html').attr('lang') === 'vi' || $('html').attr('lang') === 'hy') {
        var elementsWithDiplomacyFont = $('*').filter(function() {
            return $(this).css('font-family') === 'Diplomacy, sans-serif';
        });
        elementsWithDiplomacyFont.css({'font-family': 'Noto Sans, sans-serif', 'font-weight': 'bold'});
    }
});